import {useState, useEffect} from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

import PromotionSwitcher from "./PromotionSwitcher";
import {PromotionInterface} from "../../../interfaces/news/PromotionInterface";
import {PromotionTabs} from "./Promotions";

export default function PromotionsList({
    promotions,
    tab,
    setTab,
}: {
    promotions: PromotionInterface[];
    tab: PromotionTabs;
    setTab: (tab: PromotionTabs) => void;
}) {

    interface ButtonArrayItem {
        name: string;
        url: string | null;
    }

    const [showPromotion, setShowPromotion] = useState(false);
    const [currentPromotion, setCurrentPromotion] = useState<PromotionInterface | null>(null);
    
    const [labelFilters, setlabelFilters] = useState({ 
        is_retail: false, 
        is_online: false 
    });

    const ShowPromotion = (promotion: PromotionInterface) => {
        setCurrentPromotion(promotion);
        setShowPromotion(true);
        
        const newUrl = `${window.location.origin}${window.location.pathname}?promotion=${promotion.id}`;
        window.history.pushState({ promotionId: promotion.id }, '', newUrl);
    };

    const closePromotion = () => {
        setShowPromotion(false);
        setCurrentPromotion(null);
        
        const originalUrl = `${window.location.origin}${window.location.pathname}`;
        window.history.pushState({}, '', originalUrl);
    };

    const getButtonArrayParsed = (promotion: PromotionInterface): ButtonArrayItem[] | null => {
        const buttonArray = (promotion as any).button_array_parsed;

        if (Array.isArray(buttonArray)) {
            return buttonArray as ButtonArrayItem[];
        }
        return null;
    };

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>, promotion: PromotionInterface) => {
        event.preventDefault();

        const buttonArrayParsed = getButtonArrayParsed(promotion);
        if (buttonArrayParsed && buttonArrayParsed.length > 0) {
            const lastButton = buttonArrayParsed[buttonArrayParsed.length - 1];
            if (lastButton?.name) {
                try {
                    window.open(lastButton.name, '_blank', 'noopener,noreferrer');
                    return;
                } catch (error) {
                    console.error('Ошибка url при открытии акции:', error);
                }
            }
        }

        ShowPromotion(promotion);
    };

    const getPromotionCategory = (promotion: PromotionInterface): string => {
        if (promotion.is_online) {
            return 'Акция интернет-магазина';
        }
        if (promotion.is_retail) {
            return 'Акция розничной сети';
        }
        return '';
    };

    const handleFilterToggle = (filterName: 'is_retail' | 'is_online') => {
        setlabelFilters(prev => ({
            ...prev,
            [filterName]: !prev[filterName]
        }));
    };

    const filteredPromotions = promotions.filter(promo => {
        if (!labelFilters.is_retail && !labelFilters.is_online) {
            return true;
        }
        if (labelFilters.is_retail && promo.is_retail) {
            return true;
        }
        if (labelFilters.is_online && promo.is_online) {
            return true;
        }
        return false;
    });

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const promotionId = urlParams.get('promotion');
        
        if (promotionId) {
            const promotion = promotions.find(p => p.id.toString() === promotionId);
            if (promotion) {
                ShowPromotion(promotion);
            }
        }
    }, [promotions]);

    useEffect(() => {
        const handlePopState = (event: PopStateEvent) => {
            if (event.state?.promotionId) {
                const promotion = promotions.find(p => p.id.toString() === event.state.promotionId);
                if (promotion) {
                    setCurrentPromotion(promotion);
                    setShowPromotion(true);
                }
            } else {
                setShowPromotion(false);
                setCurrentPromotion(null);
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [promotions]);

    const getColumnClass = (index: number) => {
        const totalItems = filteredPromotions.length;
        const itemsInLastRow = totalItems % 3;
        const isLastRow = index >= totalItems - itemsInLastRow;
        
        if (isLastRow && itemsInLastRow !== 0 && itemsInLastRow < 3) {
            return "stocks__item--half";
        }
        return "col-lg-4";
    };

    return (
        <HelmetProvider>
            <Helmet>
                <title>{currentPromotion ? currentPromotion.title : 'Акции и промокоды'}</title>
            </Helmet>
            
            {showPromotion && (
                <>
                    <div className="modal-promotions__outer"  onClick={closePromotion} />
                    {currentPromotion && (
                        <div className="modal fade modal-stocks modal-promotions show" style={{display: "block"}}>
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={closePromotion}
                                    />
                                    <div className="modal-body">
                                        <div className="modal-stocks__head">
                                            <div className="modal-stocks__header-content">
                                                <h3 className="f-exp">{currentPromotion.title}</h3>
                                                <p >{currentPromotion.subtitle}</p>
                                            </div>
                                        </div>
                                        
                                        {/* 
                                        <button 
                                            className="btn btn-secondary modal-stocks__copy-btn" 
                                            onClick={() => {
                                                const url = `${window.location.origin}${window.location.pathname}?promotion=${currentPromotion?.id}`;
                                                navigator.clipboard.writeText(url).then(() => {
                                                    alert('URL акции скопирован в буфер обмена');
                                                });
                                            }}
                                        >
                                            <i className="ico ico-copy-white"></i>
                                        </button>
                                        */}

                                        <div
                                            className="modal-stocks__body "
                                            dangerouslySetInnerHTML={{__html: currentPromotion.body || ""}}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            <div className="row">
                <div className="col">
                    <h1 className="stocks__title f-exp">Акции и промокоды</h1>

                    <div className="stocks__tabs">
                        <PromotionSwitcher tab={tab} setTab={setTab} />
                    </div>

                    {tab == PromotionTabs.ACTIONS && <div className="stocks__labelFilters">
                        {[
                            { key: 'is_retail' as const, label: 'Акции розничной сети' },
                            { key: 'is_online' as const, label: 'Акции интернет-магазина' }
                        ].map(filter => (
                            <button
                                key={filter.key}
                                type="button"
                                className={`${labelFilters[filter.key] ? 'btn-labelFilters__active' : 'btn-labelFilters'}`}
                                onClick={() => handleFilterToggle(filter.key)}
                            >
                                {filter.label}
                            </button>
                        ))}
                    </div>}

                    <div className="tab-content">
                        <div className={"tab-pane show active"}>
                            <div className="stocks__list row">
                                {filteredPromotions.map((promotion, index) => (
                                    <div className={getColumnClass(index)} key={promotion.id}>
                                        <div className="stocks__item">
                                            <div className="stocks__block">
                                                <picture>
                                                    <source srcSet={promotion.image} media="(max-width: 992px)" />
                                                    <img src={promotion.image} alt={promotion.image} />
                                                </picture>
                                                <div className="stocks__block-category"> 
                                                    {getPromotionCategory(promotion)} 
                                                </div>                                         
                                                <h3 className="f-exp">{promotion.title}</h3> 
                                                <p>{promotion.subtitle}</p> 
                                            </div>

                                            <button
                                                className="btn btn-primary"
                                                onClick={(event) => handleButtonClick(event, promotion)}
                                            >
                                                {" "}
                                                Подробнее
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </HelmetProvider>
    );
}
